if (!customElements.get('shoppaint-pack-sizes')) {
  customElements.define('shoppaint-pack-sizes', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.data = JSON.parse(this.querySelector('[data-size-data]').textContent);
      this.current = this.data.products.find(p => String(p.id) === this.dataset.productId);
      this.money = new Intl.NumberFormat(document.documentElement.lang || 'en-GB', {style: 'currency', currency: this.dataset.currency || 'GBP'});
      this.onVariant = event => {
        if (String(event.detail?.product?.id) !== this.dataset.productId) return;
        this.render(event.detail.variant || null);
      };
      document.addEventListener('variant-change', this.onVariant, true);
      const picker = this.closest('.shopify-section')?.querySelector('variant-selection');
      const selected = picker?.getAttribute('variant') || this.data.selected;
      this.render(this.current?.variants.find(v => String(v.id) === String(selected)) || null);
    }
    disconnectedCallback() {
      document.removeEventListener('variant-change', this.onVariant, true);
      this.ready = false;
    }
    render(selected) {
      const target = this.querySelector('[data-size-options]');
      target.replaceChildren();
      this.querySelector('[data-size-status]').textContent = selected ? selected.title : this.dataset.choose;
      this.data.products.filter(p => p.id).forEach(product => {
        const variant = selected && product.variants.find(v => v.title === selected.title);
        const isCurrent = String(product.id) === this.dataset.productId;
        const link = document.createElement(variant && variant.available && !isCurrent ? 'a' : 'div');
        link.className = 'sp-size-option';
        if (link.tagName === 'A') {
          const url = new URL(product.url, location.origin);
          url.searchParams.set('variant', variant.id);
          const preview = new URLSearchParams(location.search).get('preview_theme_id');
          if (preview) url.searchParams.set('preview_theme_id', preview);
          link.href = url.pathname + url.search;
        }
        if (isCurrent) link.setAttribute('aria-current', 'true');
        if (variant && !variant.available) link.setAttribute('aria-disabled', 'true');
        const heading = document.createElement('strong');
        heading.textContent = product.size;
        link.append(heading);
        const detail = document.createElement('span');
        detail.textContent = variant ? this.money.format(variant.price / 100) : selected ? this.dataset.missing : this.dataset.choose;
        link.append(detail);
        if (variant) {
          const unit = document.createElement('small');
          unit.textContent = this.money.format(variant.price / 100 / product.volume) + ' ' + this.dataset.perLitre;
          link.append(unit);
          if (!variant.available || isCurrent) {
            const status = document.createElement('small');
            status.textContent = !variant.available ? this.dataset.soldOut : this.dataset.current;
            link.append(status);
          }
        }
        target.append(link);
      });
    }
  });
}
if (!customElements.get('shoppaint-delivery')) {
  customElements.define('shoppaint-delivery', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.form = this.querySelector('form');
      this.status = this.querySelector('[data-delivery-status]');
      this.rates = this.querySelector('[data-delivery-rates]');
      this.form.addEventListener('submit', event => { event.preventDefault(); this.calculate(); });
      this.form.addEventListener('input', () => { this.status.textContent = ''; this.rates.replaceChildren(); });
    }
    async calculate() {
      if (!this.form.reportValidity() || this.busy) return;
      this.busy = true;
      const button = this.form.querySelector('button');
      button.disabled = true;
      this.status.textContent = this.dataset.loading;
      this.rates.replaceChildren();
      const root = window.Shopify?.routes?.root || '/';
      const address = new FormData(this.form);
      const params = new URLSearchParams({'shipping_address[country]': 'United Kingdom', 'shipping_address[province]': address.get('region'), 'shipping_address[zip]': address.get('postcode').trim().toUpperCase()});
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 20000);
      const request = async (path, options = {}) => {
        const response = await fetch(root + path, {...options, signal: controller.signal, headers: {'Accept': 'application/json'}});
        if (!response.ok) throw new Error('request');
        return response.json();
      };
      try {
        const cart = await request('cart.js');
        if (!cart.item_count) { this.status.textContent = this.dataset.empty; return; }
        await request('cart/prepare_shipping_rates.json?' + params, {method: 'POST'});
        let result = null;
        for (let attempt = 0; attempt < 12 && !result; attempt++) {
          result = await request('cart/async_shipping_rates.json?' + params);
          if (!result) await new Promise(resolve => setTimeout(resolve, 700));
        }
        if (!result) throw new Error('timeout');
        const after = await request('cart.js');
        const fingerprint = value => JSON.stringify(value.items.map(i => [i.key, i.quantity, i.final_line_price]));
        if (fingerprint(cart) !== fingerprint(after) || String(address.get('region')) !== this.form.elements.region.value || String(address.get('postcode')) !== this.form.elements.postcode.value) throw new Error('changed');
        const money = new Intl.NumberFormat(document.documentElement.lang || 'en-GB', {style: 'currency', currency: cart.currency || this.dataset.currency || 'GBP'});
        this.status.textContent = result.shipping_rates?.length ? this.dataset.result.replace('[count]', cart.item_count).replace('[postcode]', params.get('shipping_address[zip]')) : this.dataset.noRates;
        for (const rate of result.shipping_rates || []) {
          const item = document.createElement('li');
          item.textContent = rate.name + ': ' + money.format(Number(rate.price));
          this.rates.append(item);
        }
      } catch {
        this.status.textContent = this.dataset.error;
      } finally {
        clearTimeout(timeout);
        button.disabled = false;
        this.busy = false;
      }
    }
  });
}
